import React, { useEffect, useState } from "react";
import { Menu } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import gridSvg from "../assets/svg/eye.svg";
import overviewSvg from "../assets/svg/svg13.svg";
import datasetSvg from "../assets/svg/svg14.svg";
import userSvg from "../assets/svg/svg9.svg";
import passwordSvg from "../assets/svg/svg16.svg";
import setupSvg from "../assets/svg/svg22.svg";
import { clearObj } from "../features/obj/objSlice";

const icons = {
  gridSvg,
  overviewSvg,
  datasetSvg,
  userSvg,
  passwordSvg,
  setupSvg,
};
function getItem(label, key, icon, children, type) {
  return {
    key,
    icon,
    children,
    label,
    type,
  };
}
const menuData = [
  {
    dymId: "1",
    dymLink: "dashboard",
    dymLabel: "Overview",
    mnOwner: "ALL",
    mnParentId: null,
    dymIcon: "overviewSvg",
    children: [],
  },
  {
    dymId: "2",
    dymLink: "datasets",
    dymLabel: "Datasets",
    mnOwner: "ALL",
    mnParentId: null,
    dymIcon: "datasetSvg",
    children: [],
  },
  {
    dymId: "5",
    dymLink: "setup",
    dymLabel: "Gl Setup",
    mnOwner: "ALL",
    mnParentId: null,
    dymIcon: "setupSvg",
    children: [],
  },

  {
    dymId: "3",
    dymLink: "users-list",
    dymLabel: "Users",
    mnOwner: "ALL",
    mnParentId: null,
    dymIcon: "userSvg",
    children: [],
  },
  {
    dymId: "4",
    dymLink: "reset-password",
    dymLabel: "My Account",
    mnOwner: "ALL",
    mnParentId: null,
    dymIcon: "passwordSvg",
    children: [],
  },
];
export default function SideBarClosed() {
  const { sideMenuCollapsed } = useSelector((state) => state.global);
  const { user } = useSelector((state) => state.auth);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const generateMenuItems = (menuData) => {
    if (user?.changePassword === true || user?.changePassword === null) {
      return [];
    }
    const mapItems = (items, isChild) => {
      return items?.map((item) => {
        if (item?.isTitle) {
          return {
            key: item?.dymId,
            label: item?.dymLabel,
            type: "group",
          };
        }
        const iconSrc = icons[item?.dymIcon] || gridSvg;
        return getItem(
          item?.dymLabel?.charAt?.(0)?.toUpperCase() + item?.dymLabel?.slice(1),
          item?.dymLink,
          !isChild ? <img src={iconSrc} alt={item?.dymIcon} /> : null,
          item?.children && item?.children?.length > 0
            ? mapItems(item?.children, true)
            : null
        );
      });
    };
    if (!menuData || menuData?.length === 0) {
      return [];
    }

    return mapItems(menuData);
  };
  const items = [
    ...generateMenuItems(menuData),

    {
      type: "divider",
    },
  ];

  const location = useLocation();
  const currentPath = location.pathname;

  const [lastSelectedKey, setLastSelectedKey] = useState(null);

  const handleNavigation = async (e) => {
    await setLastSelectedKey(e.key);
    await navigate(e?.key);
    await dispatch(clearObj());
  };

  const selectedKeyFromPath = currentPath?.replace("/", "");
  const validKeys = menuData?.map((item) => item?.dymLink);
  const selectedKey = validKeys?.includes(selectedKeyFromPath)
    ? selectedKeyFromPath
    : lastSelectedKey;

  useEffect(() => {}, [sideMenuCollapsed]);

  return (
    <>
      <div
        style={{
          borderInlineEnd: "1px solid rgba(5, 5, 5, 0.06)",
        }}
        className="flex flex-col h-full bg-[#f4f5f7] pt-[4.5rem]"
      >
        <Menu
          onClick={handleNavigation}
          selectedKeys={selectedKey ? [selectedKey] : []}
          // defaultSelectedKeys={["dash", "/dashboard"]}
          defaultOpenKeys={[]}
          mode="inline"
          theme="light"
          inlineCollapsed={sideMenuCollapsed}
          items={items}
        />
      </div>
    </>
  );
}
